/*
 * @Author: wang.jiang
 * @Date: 2016-2-29
 * @LastEditTime: 2021-10-27 17:47:04
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\components\service\storageLIstener\storageListenerService.js
 * @Description: 在编辑页新建修改稿件时，通过缓存刷新列表页；
 */
'use strict';


angular.module('storageLIstenerModule', []).factory('storageListenerService', [
    '$window',
    '$rootScope',
    'localStorageService',
    '$timeout',
    function ($window, $rootScope, localStorageService, $timeout) {
        var localStorage = {
            app: {
                save: '',
                send: '',
                directSign: '',
                timeSign: '',
                revoke: '',
                secondReview: '',
            },
            iwo: {
                newsSaved: '',
                newsPassed: '',
                newsSubmit: '',
                newsShared: '',
                newsCopy: '',
                newsInvoke: '',
                newsCopyDraft: '',
                newsRestore: '',
                newsDelete: '',
                manuscriptSaved: '',
                plannerOrderSaved: '',
                manuscirptSubmit: '',
                manuscriptPassed: '',
                plannerOrderSubmit: '',
                newManuscriptSaved: '',
            },
            website: {
                save: '',
                send: '',
                directSign: '',
                timeSign: '',
                pubish: '',
                reject: '',
                move: '',
                secondReview: '',
            },
            weixin: {
                save: '',
                send: '',
                directSign: '',
                rejectionDraft: '',
                revoke: '',
                revise: '',
            },
            plan: {
                modifCaland: '',
                passReport: '', // 监听报题审批
            },
            resource: {
                takeDraft: '',
            },
            platforms: {
                app: 'appdraftedit',
                iwo: 'iwonewsaddedit',
                website: 'websiteaddedit',
                plan: 'planaddedit',
                resource: 'resourceaddedit',
                weixin: 'weixinaddedit',
                television: 'tvaddedit',
                weibo: 'wbaddedit',
                broadcast: 'broadcastaddedit',
                trill: 'trilldraftedit',
                baijiahao: 'baijiahaodraftedit',
                qiehao: 'qiehaodraftedit',
                toutiaohao: 'toutiaohaodraftedit',
                editCommonDraftedit: 'editCommonDraftedit',
            },
            selectArray: {
                curPageIsNull: '',
                curPageSelectArray: [],
            },
            television: {
                save: '',
                send: '',
                directSign: '',
                timeSign: '',
                pubish: '',
                reject: '',
                move: '',
                plannerOrderSaved: '',
                withdraw: '',
                newManuscriptSaved: '',
                sign: '',
            },
            broadcast: {
                save: '',
                send: '',
                directSign: '',
                timeSign: '',
                pubish: '',
                reject: '',
                move: '',
                plannerOrderSaved: '',
                withdraw: '',
                newManuscriptSaved: '',
                sign: '',
            },
            weibo: {
                save: '',
                directSign: '',
                timeSign: '',
                withdraw: '',
                trial: '',
                revise: '',
            },
            trill: {
                save: '',
                send: '',
                trial: '',
                sign: '',
                revise: '',
            },
            baijiahao: {
                save: '',
                send: '',
                trial: '',
                sign: '',
                revise: '',
            },
            qiehao: {
                save: '',
                send: '',
                trial: '',
                sign: '',
                revise: '',
            },
            toutiaohao: {
                save: '',
                send: '',
                trial: '',
                sign: '',
            },
            draftChange: ''
        };

        var cacheCallback = [];
        return {
            removeAllListener: function () {
                for (var i = cacheCallback.length - 1; i >= 0; i--) {
                    $window.removeEventListener('storage', cacheCallback[i]);
                }
                cacheCallback = [];
            },

            /**
             * [removeListener description]移除对应平台的监听器
             * @param  {[type]} platform [description]
             * @return {[type]}          [description]
             */
            removeListener: function (platform) {
                platform = localStorage.platforms[platform];
                $timeout(function () {
                    localStorageService.remove(platform);
                }, 500);
            },

            /**
             * [listenDraftChange description] 监听稿件变化
             * @param   {[Function]}  callback  [callback description] 缓存变化后的回调函数
             * @param   {[object]}  $scope      [$scope description] 当前监听页面的$scope
             * @return  {[undefined]}           [return description]
             */
            listenDraftChange: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('editCommonDraftedit')) {
                        var localStorage = localStorageService.get('editCommonDraftedit');
                        if (localStorage) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [addListenerToDraftChange description] 监听编辑页稿件修改
             * @return  {[type]}         [return description]
             */
            addListenerToDraftChange: function () {
                localStorage.draftChange = true;
                localStorageService.set('editCommonDraftedit', localStorage.draftChange);
            },

            /**
             * [listenApp description] 监听APP缓存
             * @param   {[Function]}  callback  [callback description]
             * @param   {[type]}      $scope    [$scope description]
             * @return  {[type]}                [return description]
             */
            listenApp: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('appdraftedit')) {
                        var localStorage = localStorageService.get('appdraftedit');
                        if (
                            localStorage.save === true ||
                            localStorage.send === true ||
                            localStorage.directSign === true ||
                            localStorage.timeSign === true ||
                            localStorage.revoke === true ||
                            localStorage.secondReview === true ||
                            localStorage.revise === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [listenTrill description] 监听抖音
             * @param   {[type]}  callback  [callback description]
             * @param   {[type]}  $scope    [$scope description]
             * @return  {[type]}            [return description]
             */
            listenTrill: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('trilldraftedit')) {
                        var localStorage = localStorageService.get('trilldraftedit');
                        if (
                            localStorage.save === true ||
                            localStorage.revise === true ||
                            localStorage.trial === true ||
                            localStorage.send === true ||
                            localStorage.sign === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [listenBaijiahao description]
             *
             * @param   {[type]}  callback  [callback description]
             * @param   {[type]}  $scope    [$scope description]
             *
             * @return  {[type]}            [return description]
             */
            listenBaijiahao: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('baijiahaodraftedit') !== null) {
                        var localStorage = localStorageService.get('baijiahaodraftedit');
                        if (
                            localStorage.save === true ||
                            localStorage.revise === true ||
                            localStorage.trial === true ||
                            localStorage.send === true ||
                            localStorage.sign === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [listenQiehao description]
             *
             * @param   {[type]}  callback  [callback description]
             * @param   {[type]}  $scope    [$scope description]
             *
             * @return  {[type]}            [return description]
             */
            listenQiehao: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('qiehaodraftedit') !== null) {
                        var localStorage = localStorageService.get('qiehaodraftedit');
                        if (
                            localStorage.save === true ||
                            localStorage.revise === true ||
                            localStorage.trial === true ||
                            localStorage.send === true ||
                            localStorage.sign === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [listenToutiaohao description]
             *
             * @param   {[type]}  callback  [callback description]
             * @param   {[type]}  $scope    [$scope description]
             *
             * @return  {[type]}            [return description]
             */
            listenToutiaohao: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('toutiaohaodraftedit') !== null) {
                        var localStorage = localStorageService.get('toutiaohaodraftedit');
                        if (localStorage.save === true || localStorage.revise === true || localStorage.sign === true || localStorage.send === true) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [listenNewMedia:function description]监听新媒体渠道缓存（抖音、头条号、百家号、企鹅号）
             * @param   {[Function]}  callback [callback description]回调函数
             * @param   {[obj]}      $scope    [$scope description]作用域对象
             * @param   {[str]}      tranch   [tranch description]渠道名
             * @return  {[undefined]}         [return description]
             */
            listenNewMedia: function (callback, $scope, tranch) {
                var localStorageName = tranch + 'draftedit';
                var fn = function (e) {
                    if (localStorageService.get(localStorageName) !== null) {
                        var localStorage = localStorageService.get(localStorageName);
                        if (
                            localStorage.save === true ||
                            localStorage.revise === true ||
                            localStorage.trial === true ||
                            localStorage.send === true ||
                            localStorage.sign === true ||
                            localStorage.send === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [listenIwo description] 在列表页添加监听器
             * @param   {[type]}  callback  [callback description] 缓存变动后的回调
             * @param   {[type]}  $scope    [$scope description] null
             * @return  {[type]}            [return description]
             */
            listenIwo: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('iwonewsaddedit') !== null) {
                        var localStorage = localStorageService.get('iwonewsaddedit');
                        if (
                            localStorage.newsSaved === true ||
                            localStorage.send === true ||
                            localStorage.newsPassed === true ||
                            localStorage.newsSubmit === true ||
                            localStorage.newsShared === true ||
                            localStorage.newsCopy === true ||
                            localStorage.newsInvoke === true ||
                            localStorage.newsCopyDraft === true ||
                            localStorage.newsRestore === true ||
                            localStorage.newsDelete === true ||
                            localStorage.manuscriptSaved === true ||
                            localStorage.plannerOrderSaved === true ||
                            localStorage.manuscirptSubmit === true ||
                            localStorage.manuscriptPassed === true ||
                            localStorage.plannerOrderSubmit === true ||
                            localStorage.newManuscriptSaved === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [addListenerToApp description] 监听app编辑页修改
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            addListenerToApp: function (key) {
                localStorage.app[key] = true;
                localStorageService.set('appdraftedit', localStorage.app);
            },

            /**
             * [addListenerToTrill description] 监听抖音编辑页修改
             * @param   {[string]}  key  [key description] 操作类型
             * @return  {[type]}         [return description]
             */
            addListenerToTrill: function (key) {
                localStorage.trill[key] = true;
                localStorageService.set('trilldraftedit', localStorage.trill);
            },

            /**
             * [addListenerToBaijiahao description] 监听抖音编辑页修改
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            addListenerToBaijiahao: function (key) {
                localStorage.baijiahao[key] = true;
                localStorageService.set('baijiahaodraftedit', localStorage.baijiahao);
            },

            /**
            * [addListenerToApp description]监听抖音编辑页修改
            * @param {[type]} key [description]
            */
            addListenerToQiehao: function (key) {
                localStorage.qiehao[key] = true;
                localStorageService.set('qiehaodraftedit', localStorage.qiehao);
            }, /**
             * [addListenerToApp description]监听头条号编辑页修改
             * @param {[type]} key [description]
             */
            addListenerToToutiaohao: function (key) {
                localStorage.toutiaohao[key] = true;
                localStorageService.set('toutiaohaodraftedit', localStorage.toutiaohao);
            },

            /** [addListenerToIwo description]iwo 的编辑页修改监听项的值
             * @param {[type]} key [description] null
             */
            addListenerToIwo: function (key) {
                localStorage.iwo[key] = true;
                localStorageService.set('iwonewsaddedit', localStorage.iwo);
            },

            /**
             * [addListenerToPlan description] 策划中心概览页面修改监听项值
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            addListenerToPlan: function (key) {
                localStorage.plan[key] = true;
                localStorageService.set('planaddedit', localStorage.plan);
            },

            /**
             * [listenNewspaper description] 在报纸的列表页添加监听器
             * @param   {[type]}  callback  [callback description]
             * @param   {[type]}  $scope    [$scope description]
             * @return  {[type]}            [return description]
             */
            listenNewspaper: function (callback, $scope) {
                var fn = function (e) {
                    if (e.key === 'ls.newspaperaddedit') {
                        callback();
                    }
                };
                $window.addEventListener('storage', fn, false);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [addListenerToNewspaper description] 报纸的编辑页修改监听项的值
             * @return  {[type]}  [return description]
             */
            addListenerToNewspaper: function () {
                localStorageService.set('newspaperaddedit', Math.random());
            },

            /**
             * [listenNewspaper description] 在网站的列表页添加监听器
             * @param  {Function} callback [description] 监听项修改后触发回掉
             * @param {[object]} [$scope] [description] 调用作用域的节点scope
             * @return {[type]}            [description]
             */
            listenWebsite: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('websiteaddedit') != null) {
                        var localStorage = localStorageService.get('websiteaddedit');
                        if (
                            localStorage.save === true ||
                            localStorage.send === true ||
                            localStorage.directSign === true ||
                            localStorage.pubish === true ||
                            localStorage.reject === true ||
                            localStorage.timeSign === true ||
                            localStorage.move === true ||
                            localStorage.secondReview === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [listenPlan description]监听策划中心缓存
             * @param  {Function} callback [description]回调函数
             * @return {[type]}            [description]
             */
            listenPlan: function (callback) {
                var fn = function (e) {
                    if (localStorageService.get('planaddedit') != null) {
                        var localStorage = localStorageService.get('planaddedit');
                        if (localStorage.modifCaland === true || localStorage.passReport === true) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
            },

            /**
             * [addListenerToWebsite description] 网站的编辑页修改监听项的值
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            addListenerToWebsite: function (key) {
                localStorage.website[key] = true;
                localStorageService.set('websiteaddedit', localStorage.website);
            },

            /**
             * [listenResource description] 监听资源中心缓存
             * @param   {[type]}  callback  [callback description]
             * @param   {[type]}  scope     [scope description]
             * @return  {[type]}            [return description]
             */
            listenResource: function (callback, scope) {
                var fn = function (e) {
                    if (e.key == 'ls.resourceaddedit') {
                        callback();
                    }
                };
                try {
                    scope.$on('$destroy', function () {
                        $window.removeEventListener('storage', fn);
                    });
                } catch (e) {
                    console.log('页面监听无法移出，请在方法的第二个参数传入scope');
                } finally {
                    $window.addEventListener('storage', fn, false);
                    $rootScope.$on('resourceaddedit', function () {
                        callback();
                    });
                }
            },

            /**
             * [addListenerToResource description] 资源中心查看页取稿监听项的值
             * @return  {[type]}  [return description]
             */
            addListenerToResource: function (key) {
                localStorageService.set('resourceaddedit', { flag: Math.random() });
                $rootScope.$broadcast('resourceaddedit', { flag: Math.random() });
            },

            /**
             * [listenSelectArray description] 列表页SelectArray 的变化值
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            listenSelectArray: function (callback) {
                var fn = function (e) {
                    if (localStorageService.get('newspaperPreviewSelectArray') !== null) {
                        if (localStorage.selectArray.curPageIsNull === true) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
            },

            /**
             * [addListenerToSelectArray description] 监听列表页SelectArray上的改变
             * @param   {[type]}  key                 [key description]
             * @param   {[type]}  curPageSelectArray  [curPageSelectArray description]
             * @return  {[type]}                      [return description]
             */
            addListenerToSelectArray: function (key, curPageSelectArray) {
                localStorage.selectArray[key] = true;
                localStorage.selectArray.curPageSelectArray = curPageSelectArray;
                localStorageService.set('newspaperPreviewSelectArray', localStorage.selectArray.curPageSelectArray);
            },

            /**
             * [listenWeixin description] 在微信的列表页添加监听器
             * @param   {[type]}  callback  [callback description]
             * @param   {[type]}  $scope    [$scope description]
             * @return  {[type]}            [return description]
             */
            listenWeixin: function (callback, $scope) {
                var fn = function (e) {
                    if (e.key === 'ls.weixinaddedit') {
                        callback();
                    }
                };
                $window.addEventListener('storage', fn, false);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [addListenerToWeixin description] 微信的编辑页修改监听项的值
             * @return  {[type]}  [return description]
             */
            addListenerToWeixin: function () {
                localStorageService.set('weixinaddedit', Math.random());
            },

            /**
             * [previewPageTurningStorage description] 预览翻页数据存储
             * @param {array} [list] [description] 列表数据
             * @param {string} [attributes] [description] 属性信息
             * @param {string} [location] [description] 存储位置
             * @return {[type]} [description]
             */
            previewPageTurningStorage: function (list, attributes, location) {
                if (!list || list.length == 0) {
                    return;
                }
                list = angular.copy(list);
                var attrArray = attributes.split(',');
                localStorageService.remove(location);
                for (var i = 0; i < list.length; i++) {
                    var item = list[i];
                    for (var j in item) {
                        if (attrArray.indexOf(j) < 0) {
                            delete item[j];
                        }
                    }
                }
                localStorageService.set(location, JSON.stringify(list));
            },

            /**
             * [appendPageTurningStorage description] 追加预览翻页数据（用于资源中心稿件详情页相关稿件的点击预览）
             * @param  {[type]} list          [description] 列表数据
             * @param  {[type]} attributes    [description] 属性信息
             * @param  {[type]} location      [description] 存储位置
             * @param  {[type]} newAttributes [description] 转存属性
             * @return {[type]}               [description]
             */
            appendPageTurningStorage: function (list, attributes, location, newAttributes) {
                if (!list || list.length == 0) {
                    return;
                }
                list = angular.copy(list);
                var newList = [];
                var attrArray = attributes.split(',');
                var newAttrArray = newAttributes.split(',');
                for (var i = 0; i < list.length; i++) {
                    var item = list[i];
                    var itemNew = {};
                    for (var j in attrArray) {
                        var attr = attrArray[j];
                        itemNew[newAttrArray[j]] = item[attr];
                    }
                    newList.push(itemNew);
                }
                var orgList = localStorageService.get('resourceDetail') ? JSON.parse(localStorageService.get('resourceDetail')) : [];
                orgList = orgList.concat(newList);
                localStorageService.set(location, JSON.stringify(orgList));
            },

            /**
             * [relatedPageTurningStorage description] 翻页数据（用于资源中心稿件详情页中 关联稿件 和 高级检索结果）
             * @param   {[type]}  list           [list description] 列表数据
             * @param   {[type]}  attributes     [attributes description] 属性信息
             * @param   {[type]}  location       [location description] 存储位置
             * @param   {[type]}  newAttributes  [newAttributes description] 转存属性
             * @return  {[type]}                 [return description]
             */
            relatedPageTurningStorage: function (list, attributes, location, newAttributes) {
                if (!list || list.length == 0) {
                    return;
                }
                list = angular.copy(list);
                var newList = [];
                var attrArray = attributes.split(',');
                var newAttrArray = newAttributes.split(',');
                for (var i = 0; i < list.length; i++) {
                    var item = list[i];
                    var itemNew = {};
                    for (var j in attrArray) {
                        var attr = attrArray[j];
                        itemNew[newAttrArray[j]] = item[attr];
                    }
                    newList.push(itemNew);
                }
                localStorageService.set(location, JSON.stringify(newList));
            },

            /**
             * [addListenerToTv description] 电视的编辑页修改监听项的值
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            addListenerToTv: function (key) {
                localStorage.television[key] = true;
                localStorageService.set('tvaddedit', localStorage.television);
            },

            /**
             * [listenTelevision description] 在电视渠道的列表页添加监听器
             * @param  {Function} callback [description] 监听项修改后触发回掉
             * @param {[object]} [$scope] [description] 调用作用域的节点scope
             * @return {[type]}            [description]
             */
            listenTelevision: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('tvaddedit') != null) {
                        var localStorage = localStorageService.get('tvaddedit');
                        if (
                            localStorage.save === true ||
                            localStorage.send === true ||
                            localStorage.directSign === true ||
                            localStorage.pubish === true ||
                            localStorage.reject === true ||
                            localStorage.timeSign === true ||
                            localStorage.move === true ||
                            localStorage.plannerOrderSaved === true ||
                            localStorage.withdraw === true ||
                            localStorage.newManuscriptSaved === true ||
                            localStorage.sign === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [addListenerToBroadcast description] 电视的编辑页修改监听项的值
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            addListenerToBroadcast: function (key) {
                localStorage.broadcast[key] = true;
                localStorageService.set('broadcastaddedit', localStorage.broadcast);
            },

            /**
             * [listenBroadcast description] 在广播渠道的列表页添加监听器
             * @param  {Function} callback [description] 监听项修改后触发回掉
             * @param {[object]} [$scope] [description] 调用作用域的节点scope
             * @return {[type]}            [description]
             */
            listenBroadcast: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('broadcastaddedit') != null) {
                        var localStorage = localStorageService.get('broadcastaddedit');
                        if (
                            localStorage.save === true ||
                            localStorage.send === true ||
                            localStorage.directSign === true ||
                            localStorage.pubish === true ||
                            localStorage.reject === true ||
                            localStorage.timeSign === true ||
                            localStorage.move === true ||
                            localStorage.plannerOrderSaved === true ||
                            localStorage.withdraw === true ||
                            localStorage.newManuscriptSaved === true ||
                            localStorage.sign === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },

            /**
             * [addListenerToWeibo description] 微博的编辑页修改监听项的值 
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            addListenerToWeibo: function (key) {
                localStorage.weibo[key] = true;
                localStorageService.set('wbaddedit', localStorage.weibo);
            },

            /**
             * [listenToWeibo description] 在微博的列表页添加监听器
             * @param  {Function} callback [description] 监听项修改后触发回掉
             * @param {[object]} [$scope] [description] 调用作用域的节点scope
             * @return {[type]}            [description]
             */
            listenToWeibo: function (callback, $scope) {
                var fn = function (e) {
                    if (localStorageService.get('wbaddedit') != null) {
                        var localStorage = localStorageService.get('wbaddedit');
                        if (
                            localStorage.save === true ||
                            localStorage.send === true ||
                            localStorage.directSign === true ||
                            localStorage.timeSign === true ||
                            localStorage.withdraw === true ||
                            localStorage.revise === true
                        ) {
                            callback();
                        }
                    }
                };
                $window.addEventListener('storage', fn, false);
                cacheCallback.push(fn);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('storage', fn);
                });
            },
        };
    },
]);
